// New Arrivals: preload/decode all unique images before starting the marquee.
// This avoids blank cards on refresh and prevents the animation from outrunning image decoding.
(function(){
  const track=document.querySelector('.arrival-track');
  if(!track)return;
  if(matchMedia('(max-width:940px), (hover:none)').matches){track.classList.add('is-ready');return;}
  const urls=[...new Set([...track.querySelectorAll('img')].map(img=>img.currentSrc||img.src))];
  const jobs=urls.map(src=>new Promise(resolve=>{
    const img=new Image();
    img.decoding='async';
    img.onload=()=>{ if(img.decode){ img.decode().catch(()=>{}).finally(resolve); } else resolve(); };
    img.onerror=resolve;
    img.src=src;
  }));
  Promise.all(jobs).then(()=>requestAnimationFrame(()=>track.classList.add('is-ready')));
  // Safety fallback: never leave the carousel stopped if one browser stalls decode.
  setTimeout(()=>track.classList.add('is-ready'),2500);
})();

// custom sign preview
(function(){
  const input=document.getElementById('builderInput'),preview=document.getElementById('neonPreview'),bg=document.getElementById('builderBg'),scene=document.getElementById('sceneSelect'),font=document.getElementById('fontSelect'),type=document.getElementById('builderType'),typeLabel=document.getElementById('builderTypeLabel'),onBtn=document.getElementById('lightOn'),offBtn=document.getElementById('lightOff'),colors=[...document.querySelectorAll('#colorGrid button')];
  if(!input)return;
  input.addEventListener('input',()=>preview.textContent=input.value||'Cat\nIdea');
  scene.addEventListener('change',()=>bg.style.backgroundImage=`url('${scene.value}')`); bg.style.backgroundImage=`url('${scene.value}')`;
  font.addEventListener('change',()=>preview.style.fontFamily=font.value); preview.style.fontFamily=font.value;
  type.addEventListener('change',()=>typeLabel.textContent=type.value);
  colors.forEach(b=>b.addEventListener('click',()=>{colors.forEach(x=>x.classList.remove('active'));b.classList.add('active');preview.style.color=b.dataset.color;preview.style.textShadow=`0 0 5px ${b.dataset.color},0 0 12px ${b.dataset.color},0 0 28px ${b.dataset.color}`;onBtn.classList.add('active');offBtn.classList.remove('active');}));
  onBtn.addEventListener('click',()=>{onBtn.classList.add('active');offBtn.classList.remove('active');preview.style.opacity='1';preview.style.removeProperty('text-shadow')}); offBtn.addEventListener('click',()=>{offBtn.classList.add('active');onBtn.classList.remove('active');preview.style.opacity='.28';preview.style.textShadow='none'});
})();

// Include the current builder choices in the shared Shopify contact form.
document.addEventListener('consult:prepare', event => {
  if (event.target.closest('[data-consult-without-selections]')) return;
  const builder = event.target.closest('.custom-builder-section');
  if (!builder) return;
  const selectedLabel = selector => builder.querySelector(selector)?.selectedOptions[0]?.textContent.trim() || 'Not selected';
  const color = builder.querySelector('#colorGrid button.active');
  const details = [
    'Homepage sign builder',
    `Sign text: ${builder.querySelector('#builderInput')?.value || ''}`,
    `Scene: ${selectedLabel('#sceneSelect')}`,
    `Font: ${selectedLabel('#fontSelect')}`,
    `Color: ${color ? `${color.getAttribute('aria-label')} (${color.dataset.color})` : 'Default'}`,
    `Product type: ${selectedLabel('#builderType')}`,
    `Preview light: ${builder.querySelector('#lightOff')?.classList.contains('active') ? 'OFF' : 'ON'}`
  ];
  builder.querySelectorAll('.builder-meta > span').forEach(item => details.push(item.textContent.trim()));
  const total = builder.querySelector('.builder-total span')?.textContent.trim();
  if (total) details.push(`Displayed total: ${total}`);
  event.detail.configuration = details.join('\n');
  event.detail.source = 'Homepage sign builder inquiry';
});
